import { CalendarDots } from "@phosphor-icons/react";

import { TemplateEditor } from "features/templates/components/index";
import VoiceTemplate from "features/templates/components/VoiceTemplate";
import { TEMPLATE_TYPES } from "features/templates/constants";
import type {
  TemplateSchemaType,
  VoiceTemplateSchemaType,
} from "features/templates/schemas";

import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import { formatDate } from "common/helpers/utils";

import type { JSX } from "react";
import type { UseFormReturn } from "react-hook-form";

export default function DesktopTemplate({
  previewComponent,
  form,
  //when this is true, the name input field is displayed
  isCreatingNew = false,
  isDisabled = false,
}: {
  previewComponent: JSX.Element;
  form: UseFormReturn<TemplateSchemaType>;
  isCreatingNew?: boolean;
  isDisabled?: boolean;
}) {
  return (
    <>
      {isCreatingNew && (
        <div className="flex justify-between items-center gap-x-2">
          <FormField
            size="sm"
            label="Template name"
            htmlFor="templateName"
            className="flex-1"
            error={form.formState.errors.name?.message}
          >
            <Input
              variant="sm"
              placeholder={`New ${TEMPLATE_TYPES[form.getValues("type")].shortLabel.toLowerCase()} template`}
              {...form.register("name")}
              hasError={!!form.formState.errors.name?.message}
            />
          </FormField>
          <div className="flex flex-1 items-center justify-end gap-x-0.5 pl-1.5 text-black-500">
            <CalendarDots className="size-4" />
            <span className="text-xs-medium">
              Created: {formatDate(Date.now())}
            </span>
          </div>
        </div>
      )}
      {form.getValues("type") === "VOICE_TEMPLATE" ? (
        <VoiceTemplate
          form={form as UseFormReturn<VoiceTemplateSchemaType>}
          isEditable={!isDisabled}
        />
      ) : (
        <div className="flex gap-x-2 overflow-hidden p-0.5 -m-0.5">
          <TemplateEditor
            form={
              form as UseFormReturn<
                Exclude<TemplateSchemaType, VoiceTemplateSchemaType>
              >
            }
            isEditable={!isDisabled}
          />
          {previewComponent}
        </div>
      )}
    </>
  );
}
